module.exports = __webpack_public_path__ + "static/event-1-07ebfe6ee527c16617b21964396ed697.mp4";